/**
 * This is the Fallback component consumers will use to wrap the module with the `ModuleWrapper`.
 *
 * @example
 * <ModuleWrapper fallback={<FallbackButtonLocale />} ...>
 *   <ButtonLocale ... />
 * </ModuleWrapper>
 */
export default function FallbackButtonLocale() {
  return null;
}